import { render, staticRenderFns } from "./TrainingExerciseFilterDialog.vue?vue&type=template&id=2607cfa6"
import script from "./TrainingExerciseFilterDialog.vue?vue&type=script&lang=js"
export * from "./TrainingExerciseFilterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports